import { render, staticRenderFns } from "./billInfo.vue?vue&type=template&id=3ef3704e&scoped=true"
import script from "./billInfo.vue?vue&type=script&lang=js"
export * from "./billInfo.vue?vue&type=script&lang=js"
import style0 from "./billInfo.vue?vue&type=style&index=0&id=3ef3704e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ef3704e",
  null
  
)

export default component.exports